import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import { CheckCircle as CheckCircleIcon } from "@material-ui/icons";
import {
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";

import { createOrderRequest, clearSelectedProduct } from "../Purchase/store/actions";
import { getProfileRequest } from "../Profile/store/actions";
import Button from "../../components/Button";
import * as localStorage from "../../utils/localStorage";
import { useStyles } from "./styles";
import { getProductThumbnail } from "../Purchase/productImages";

export const PurchaseConfirmation = (props) => {
  const {
    selectedProduct,
    isCreatingOrder,
    createOrder,
    clearProduct,
    profile,
    getProfile,
  } = props;
  const classes = useStyles();
  const history = useHistory();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  useEffect(() => {
    if (!profile?.username) {
      getProfile();
    }
  }, [getProfile, profile?.username]);

  const localProfile = localStorage.getItem("profile") || {};
  const displayUsername =
    profile?.username ||
    localProfile?.username ||
    profile?.email ||
    localProfile?.email ||
    "User";

  const handleBack = () => {
    clearProduct();
    history.push("/pilot/purchase");
  };

  const handleOpenConfirmModal = () => {
    setOpenConfirmModal(true);
  };

  const handleCloseConfirmModal = () => {
    if (!isCreatingOrder) {
      setOpenConfirmModal(false);
    }
  };

  const handleConfirmPayment = () => {
    if (selectedProduct) {
      createOrder(selectedProduct.name);
    }
  };

  if (!selectedProduct) {
    return (
      <div className={classes.container}>
        <div className={classes.content}>
          <div className={classes.header}>
            <CheckCircleIcon />
            <span>Payment Confirmation</span>
          </div>
          <div className={classes.emptyContainer}>
            <div className={classes.emptyText}>
              No product selected
            </div>
            <Button text="Back" onClick={handleBack} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.header}>
          <CheckCircleIcon />
          <span>Payment Confirmation</span>
        </div>
        <Paper className={classes.card}>
          <img
            src={getProductThumbnail(selectedProduct)}
            alt={selectedProduct.title}
            className={classes.productImage}
          />
          <div className={classes.productTitle}>{selectedProduct.title}</div>
          <div className={classes.productDescription}>
            {selectedProduct.description}
          </div>

          <div className={classes.infoRow}>
            <div className={classes.infoLabel}>Package:</div>
            <div className={classes.infoValue}>{selectedProduct.name}</div>
          </div>

          <div className={classes.infoRow}>
            <div className={classes.infoLabel}>Duration:</div>
            <div className={classes.infoValue}>{selectedProduct.value} months</div>
          </div>

          <div className={`${classes.infoRow} ${classes.priceRow}`}>
            <div className={classes.totalLabel}>Total:</div>
            <div className={classes.totalPrice}>${selectedProduct.price}</div>
          </div>

          <div className={classes.buttonContainer}>
            <Button
              text="Back"
              onClick={handleBack}
              classes={`${classes.button} ${classes.backButton}`}
              disabled={isCreatingOrder}
            />
            <Button
              text="Pay Now"
              onClick={handleOpenConfirmModal}
              classes={`${classes.button} ${classes.paymentButton}`}
              isLoading={isCreatingOrder}
            />
          </div>
        </Paper>
      </div>

      <Dialog
        open={openConfirmModal}
        onClose={handleCloseConfirmModal}
        aria-labelledby="confirm-order-dialog-title"
        aria-describedby="confirm-order-dialog-description"
        PaperProps={{
          className: classes.dialogPaper,
        }}
      >
        <DialogTitle id="confirm-order-dialog-title" className={classes.dialogTitle}>
          Confirm Order
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <DialogContentText
            id="confirm-order-dialog-description"
            className={classes.dialogText}
          >
            Are you sure you want to order package{" "}
            <span className={classes.highlightPackage}>{selectedProduct.title}</span> for user{" "}
            <span className={classes.highlightUsername}>{displayUsername}</span>?
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            text="No"
            onClick={handleCloseConfirmModal}
            classes={`${classes.dialogButton} ${classes.dialogNoButton}`}
            disabled={isCreatingOrder}
          />
          <Button
            text="Yes"
            onClick={handleConfirmPayment}
            classes={`${classes.dialogButton} ${classes.dialogYesButton}`}
            isLoading={isCreatingOrder}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedProduct: state.purchase.selectedProduct,
  isCreatingOrder: state.purchase.isCreatingOrder,
  profile: state.profile?.profile || {},
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createOrder: createOrderRequest,
      clearProduct: clearSelectedProduct,
      getProfile: getProfileRequest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseConfirmation);
